import { dossiers } from '../services/bff.api';
import { CLARIFICATION_STAKEHOLDERS_RESOURCE } from './clarification.stakeholders.resource';

export const DOSSIER_OVERVIEW_STAKEHOLDERS_RESOURCE = {
  ...CLARIFICATION_STAKEHOLDERS_RESOURCE,
  table: {
    ...CLARIFICATION_STAKEHOLDERS_RESOURCE.table,
    fields: [...CLARIFICATION_STAKEHOLDERS_RESOURCE.table.fields, { value: 'tab', label: 'Fase', show: true, order: 5 }]
  },
  api: {
    getById: (id) => dossiers.getById(id)
  },
  key: 'DOSSIER_OVERVIEW_STAKEHOLDERS_RESOURCE'
};
